<template>
	<div class="parent" style="height:calc(100vh - 50px);">
        <dialogue
		:title="'Preparing'"
		:paragraph="'Preparing invoice, this may take a while'"
		:show="prepare_dialogue"
		></dialogue>

		<layout-3 :id=pageid1 :term=term :width=3 :height=2 style="max-height:30vh;"></layout-3>
		<hr style="margin-left:25px;margin-right:25px;"/>
		<div style="height:12px; padding:0px 15px 0px 15px; font-size:10px"><b>Master Job Order</b></div>
		<div style="height:30px; padding:0px 15px 0px 15px; font-size:16px" id="jobInfoText"></div>
		<hr style="margin-left:25px;margin-right:25px;"/>
		<div style="overflow-y:auto; margin-bottom:10px;">

			<div v-if="termSplit[1]=='4'" :key=update_key>

				<div class="lefttable">
					<layout-1
					:table_name="'Job Orders Assigned To Contract'"
					:id=pageid3
					:searchbar=false
					:height_limit="false"
					:auto_reload=false
					:button_perm="'83'"
					:button_name="'Remove'"
					v-on:select="selectLink"
					:term=termSplit></layout-1>

					<layout-1
					:table_name="'Available Job Orders'"
					:id=pageid2
					:searchbar=false
					:height_limit="false"
					:auto_reload=false
					:button_perm="'83'"
					:button_name="'Add'"
					v-on:select="select"
					:term=termSplit></layout-1>
				</div>

				<div class="righttable">
					<div>
						<button v-on:click="changePage(-1)" style="float:left; width:100px;"><</button>
						<button v-on:click="changePage(1)" style="float:right; width:100px;">></button>
						<p style="margin:0 auto 0 auto; width:100px; text-align:center;">{{invDocPage}} / {{documents.length}}</p>
					</div>

					<layout-13
						v-if="invDocPage==0"
						:term="termSplit"
						:showMiscText=true
						style="width:100%"
					></layout-13>

					<div class="scroll" style="width:95%; height:calc(100vh - 225px);" v-for="(documentid, index) in documents" v-if="index+1 == invDocPage">
						<document :id="index" :dir="'doc_'+documentid+'.jpg'" :doc_id="documentid"></document>
					</div>
				</div>

			</div>

			<layout-1 v-else
			:table_name="'Job Orders'"
			:id=pageid2
			:searchbar=false
			:height_limit="false"
			:navbar=false
			:select_reroute=true
			:button_perm="'83'"
			:button_name="'Select'"
			:term=termSplit></layout-1>

		</div>
		<div class="nav-bar">
			<div>
				<button v-on:click="prepareInvoice()">Prepare Invoice</button>
				<button v-on:click="addAll()">Add All Available Job Orders</button>
				<button v-on:click="removeAll()">Remove All Assigned Job Orders</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return {
			perms:[],

			pageid1:PAGES.VIEW_CONTRACTS_PAGE,
			pageid2:PAGES.CONTRACT_JOBORDERS_PAGE,
			pageid3:PAGES.CONTRACT_JOBORDERS_LINKED_PAGE,
			pageid4:PAGES.CONTRACT_PREPARE_PAGE,
			pageid5:PAGES.CONTRACT_DOCUMENTS_PAGE,

			termSplit:[],

			column_names:[],
			column_data:[],

			documents:[],
			invDocPage:0,

			update_key:0,

            prepare_dialogue:false,
            isStatusCompleted:false,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.termSplit=this.term.split(';');
		this.getMasterJoborder();
		this.getDocuments();
	},
	methods:{
		select(column, refresh = true){
            if (this.isStatusCompleted == true && !this.perms.includes('133')) {
                alert('Could not save, invoice is completed')
                return
            }

			return (api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid2,
						data:[
							column[0],
							this.termSplit,
						],
					}
				}
			).then((res)=>{
				if(refresh==true){
					this.update_key++;
					this.getDocuments();
				}
			}))

		},
		addAll(){

			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						data:[
							this.termSplit
						],
					}
				}
			).then((res) => {

				var column = res.data.data.column_data;

				let promises = [];
				for(let i = 0;i<column.length;i++){
					promises.push(this.select(column[i],false));
				}

				Promise.all(promises).then((results) => {
					this.update_key++;
					this.getDocuments();
				});

			})
		},
		selectLink(column, refresh = true){
            if (this.isStatusCompleted == true && !this.perms.includes('133')) {
                alert('Could not save, invoice is completed')
                return
            }

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid3,
						data:[
							column[0],
							this.termSplit,
						],
					}
				}
			).then((res)=>{
				if(refresh==true){
					this.update_key++;
					this.getDocuments();
				}
			})

		},
		removeAll(){

			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid3,
						data:[
							this.termSplit
						],
					}
				}
			).then((res) => {

				var column = res.data.data.column_data;

				let promises = [];
				for(let i = 0;i<column.length;i++){
					promises.push(this.selectLink(column[i],false));
				}

				Promise.all(promises).then((results) => {
					this.update_key++;
					this.getDocuments();
				});

			})
		},
		getMasterJoborder(){

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid1,
						data:[
							this.termSplit,
						],
					}
				}
			).then((res) => {
				var text = ""
				for(var i = 0;i<res.data.data.column_names.length;i++){
					text+="<div style='float:left; height:30px'>"
					text+="<b>"+res.data.data.column_names[i]+":</b> "
					if(i==0){
						text+="<p style='float:right; height:30px; margin-right:10px;'>"+res.data.data.column_data[0][i]+"</p>"
					}else{
						text+=res.data.data.column_data[0][i]
					}
					text+="&emsp;</div>"

                    if (res.data.data.column_names[i] == "Status") {
                        if (res.data.data.column_data[0][i] == "Completed") {
                            this.isStatusCompleted = true
                        }else {
                            this.isStatusCompleted = false
                        }
                    }
				}
				document.getElementById("jobInfoText").innerHTML = text;
			});

		},
		prepareInvoice(){
            if (this.isStatusCompleted == true && !this.perms.includes('133')) {
                alert('Could not save, invoice is completed')
                return
            }

            this.prepare_dialogue = true;

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid4,
						data:[
							this.termSplit,
						],
					}
				}
			).then((res)=>{
                this.prepare_dialogue = false
				alert(res.data.message);
			})
		},
		getDocuments(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid5,
						data:[
							this.termSplit
						],
					}
				}
			).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					this.documents = [];
					for(var i = 0;i<res.data.data.column_data.length;i++){
						this.documents.push(res.data.data.column_data[i][0]);
					}
				}
			})
		},
		changePage(amt){
			this.invDocPage+=amt;
			if(this.invDocPage<0){
				this.invDocPage=0;
			}

			if(this.invDocPage>this.documents.length){
				this.invDocPage=this.documents.length;
			}
		},
	},
	watch:{
		term(){
			this.termSplit=this.term.split(';');
		},
	}
}
</script>

<style scoped>
.lefttable{
	width:64%;
	float:left;
}

.righttable{
	max-width:34%;
	float:right;
}
</style>



// WEBPACK FOOTER //
// src/components/view/View_Contracts.vue